import PropTypes from 'prop-types';

export const defaultProps = {};

export const propTypes = {
  /**
   * PopConfirm 组件接收的 props
   * 默认：-
   */
  popConfirmProps: PropTypes.object,

  /**
   * Button 组件接收的 props
   * 默认：-
   */
  buttonProps: PropTypes.object
};
